import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppSidebar, Flyout, Navbar } from 'containers';
import { connect } from 'react-redux';
import * as styles from './AppLayout.scss';
var AppLayout = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    routing: state.routing
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AppLayout, _Component);

  var _super = _createSuper(AppLayout);

  function AppLayout() {
    _classCallCheck(this, AppLayout);

    return _super.apply(this, arguments);
  }

  _createClass(AppLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appLayoutInnerStyle = _this$props.appLayoutInnerStyle,
          children = _this$props.children,
          organization = _this$props.organization;
      var appLinks = [{
        name: 'global',
        link: "/org/".concat(organization.id, "/client-detail"),
        iconName: 'ion-ios-world-outline',
        tooltip: 'Client Detail',
        partnerOnly: true
      }, {
        name: 'content',
        link: "/org/".concat(organization.id, "/content"),
        iconName: 'ion-ios-lightbulb-outline',
        tooltip: 'Content Library',
        partnerOnly: false
      }, {
        name: 'publishing',
        link: "/org/".concat(organization.id, "/publishing"),
        iconName: 'ion-ios-calendar-outline',
        tooltip: 'Publishing',
        partnerOnly: false
      }, //Hide this for now until Messaging feature is improved
      // {
      //   name: 'message center',
      //   link: `/org/${organization.id}/message-center`,
      //   iconName: 'ion-ios-chatbubble-outline',
      //   tooltip: 'Message Center',
      //   partnerOnly: false
      // },
      {
        name: 'ads',
        link: "/org/".concat(organization.id, "/ads"),
        svgIcon: 'bullhorn',
        tooltip: 'Advertising',
        partnerOnly: false
      }, {
        name: 'reports',
        link: "/org/".concat(organization.id, "/reports"),
        iconName: 'ion-ios-pulse',
        tooltip: 'Reporting',
        partnerOnly: false
      }, {
        name: 'settings',
        link: "/org/".concat(organization.id, "/settings"),
        iconName: 'ion-ios-gear-outline',
        tooltip: 'Settings',
        partnerOnly: false
      }];
      var hasOrgCancelledMessage = organization.status === 'cancelled' || organization.status === 'pending_cancel';
      var hasOrgPastDueMessage = organization.gracePeriodState && ['1', '2', '3'].indexOf(organization.gracePeriodState) !== -1;
      var notAdminPage = !this.props.routing || !this.props.routing.locationBeforeTransitions || this.props.routing && this.props.routing.locationBeforeTransitions && this.props.routing.locationBeforeTransitions.pathname.indexOf('/global') === -1;
      var hasBannerMessage = (hasOrgPastDueMessage || hasOrgCancelledMessage) && notAdminPage;
      return /*#__PURE__*/React.createElement("div", {
        id: "AppLayout",
        className: styles.layout
      }, /*#__PURE__*/React.createElement(Navbar, {
        position: "fixed",
        text: "Likeable",
        params: _objectSpread({}, this.props.params)
      }), !this.props.adminPage && /*#__PURE__*/React.createElement(AppSidebar, {
        links: appLinks,
        verticalMenuStyle: {
          marginTop: hasBannerMessage ? 44 : 0
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, appLayoutInnerStyle), {}, {
          marginTop: hasBannerMessage ? 44 : 0
        })
      }, children), /*#__PURE__*/React.createElement(Flyout, {
        icons: this.props.flyoutIcons,
        flyoutStyle: {
          marginTop: hasBannerMessage ? 44 : 0
        }
      }, this.props.rightPanel));
    }
  }]);

  return AppLayout;
}(Component), _defineProperty(_class2, "propTypes", {
  children: PropTypes.array.isRequired,
  organization: PropTypes.object.isRequired,
  appLayoutInnerStyle: PropTypes.object,
  rightPanel: PropTypes.node
}), _defineProperty(_class2, "defaultProps", {
  adminPage: false,
  appLayoutInnerStyle: {
    display: 'flex',
    flex: '1 1 auto',
    padding: 36,
    overflow: 'scroll',
    overflowX: 'hidden',
    height: '100%'
  }
}), _temp)) || _class);
export default AppLayout;